"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var history_1 = require("../../stores/history");
var playlist_1 = require("../../selectors/playlist");
function addRotationToHistory() {
    var action = function (dispatch, getState) {
        var _a;
        var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/addRotationHistoryItem");
        var state = getState();
        var prevPlaylistItem = (0, playlist_1.selectCurrentPlaylistItem)(state);
        if (prevPlaylistItem) {
            logger.debug("Save rotation in history", { prevPlaylistItem: prevPlaylistItem });
            dispatch((0, history_1.addHistory)(__assign(__assign({}, prevPlaylistItem), { playStartedAt: (_a = prevPlaylistItem.playStartedAt) !== null && _a !== void 0 ? _a : 0 })));
        }
        else {
            logger.debug("Rotation was not found to save in history");
        }
    };
    action.type = addRotationToHistory.type;
    return action;
}
addRotationToHistory.type = "addRotationToHistory";
exports.default = addRotationToHistory;
//# sourceMappingURL=addRotationToHistory.js.map